/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/require-computed-property-dependencies */
import { computed } from '@ember/object';
import Predicate from 'predicates/models/predicate';
export default Predicate.extend({
  isEditable: true,
  isUrlVisitType: true,
  genericType: 'urlVisit',
  defaultComparison: 'eq',
  description: computed('attribute', 'comparison', 'type', 'value', function () {
    let url = this.get('value.url') ? this.get('value.url') : '';
    return `for ${url} ${this.getDescription().shortText}`;
  }),
  isValidForValue: computed('value', function () {
    let url = this.get('value.url');
    let count = this.get('value.count');
    if (isNaN(count)) {
      return false;
    }
    return url && parseInt(count, 10) >= 0;
  }),
  getDefaultValue() {
    return {
      url: '',
      count: ''
    };
  }
});